<template>
  <v-app>
    <v-app-bar
      app
      color="primary"
      dark
    >
      <div class="d-flex align-center title">
        Mister Paradise Jeep Rental Curacao
      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-content>
      <GetUserData v-if="$store.state.status==0"/>
      <PreBookFrom v-if="$store.state.status==1"/>
      <Finalize v-if="$store.state.status==2"/>
    </v-content>
  </v-app>
</template>

<script>
import GetUserData from './components/GetUserData'
import PreBookFrom from './components/PreBookFrom'
import Finalize from './components/Finalize'

export default {
  name: 'App',

  components: {
    GetUserData,
    PreBookFrom,
    Finalize
  },

  data: () => ({
    //
  }),
};
</script>
